import { Role } from "../../types/role";

const CARun: Role = {
  primary: [
    "Passen",
    "Tackling",
    "Einsatzfreude",
    "Entscheidungen",
    "Stellungsspiel",
    "Teamwork",
    "Ausdauer",
  ],
  secondary: [
    "Ballannahme",
    "Technik",
    "Antizipation",
    "Konzentration",
    "Nervenstaerke",
    "OhneBall",
    "Uebersicht",
  ],
  physis: "mittelfeld",
};

export const CAR = {
  CARun,
};
